module.exports = __webpack_public_path__ + "img/86.c4bdeaab.jpg";